var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessDot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "88px",
    viewBox: "0 0 88 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/small/rounded") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 43.5,
    cy: 43.5,
    r: 43.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contact-dialog",
    transform: "translate(-596.000000, -216.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/small/rounded",
    transform: "translate(596.750000, 216.776385)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Oval-Copy-7",
    fill: "#80E0C9",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "swatch/blue",
    mask: "url(#mask-2)",
    fill: "#80E0C9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 87,
    height: 87
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.5335101,33.1922143 C61.8115597,32.4359286 60.6410712,32.4359286 59.9189764,33.1922143 L37.7698229,56.3926685 L29.2560507,47.4748807 C28.5341003,46.7185949 27.3636119,46.7186706 26.641517,47.4748807 C25.9194943,48.2310908 25.9194943,49.457124 26.641517,50.2134098 L36.4625561,60.5003486 C37.1842899,61.2565588 38.3556449,61.2560293 39.0770898,60.5003486 L62.5335101,35.9308191 C63.2555327,35.1746089 63.2554605,33.9485001 62.5335101,33.1922143 Z",
    id: "Path",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessDot);
export default __webpack_public_path__ + "static/media/success-dot.3971b4ef14070b6b94fb55f57a4b9003.svg";
export { ForwardRef as ReactComponent };